<template lang="pug">
.c-cms-purpose
  article-editor(title="宗旨"
    type="other"
    :docRef="docRef"
    @succeed-confirm="$router.push({ name: 'cms' })")
</template>

<script>
import { db } from "@/firebase";
import ArticleEditor from "@/components/cms/ArticleEditor.vue";

export default {
  name: "CmsPurpose",
  components: {
    ArticleEditor
  },
  data() {
    return {
      docRef: db.collection("articles").doc("purpose")
    };
  }
};
</script>
